import axios from "axios";

const state = {
  branches: [],
};

const mutations = {
  SET_BRANCHES(state, branches) {
    if (branches && branches.data && Array.isArray(branches.data)) {
      state.branches = branches.data;
    } else {
      state.branches = []; // Set default ke array kosong jika tidak ada data valid
    }
  },
  ADD_BRANCH(state, branch) {
    state.branches.push(branch);
  },
  UPDATE_BRANCH(state, branch) {
      const index = state.branches.findIndex(item => item.id == branch.id);
      if (index !== -1) {
        state.branches.splice(index, 1, branch);
      }
  },
  REMOVE_BRANCH(state, id) {
      state.branches = state.branches.filter(item => item.id !== id);
  }
};

const actions = {
  async fetchBranches({ commit, dispatch }) {
    dispatch('loading/showLoading', null, { root: true });

    try {
      const token = localStorage.getItem("auth_token");
      const response = await axios.get(
        `${process.env.VUE_APP_ROOT_API}/branches`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await response.data;
      commit("SET_BRANCHES", data);
    }
    catch (error) {
      console.error("Error fetching branches:", error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },
  createBranch({ commit }, branch) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("auth_token");
      axios
        .post(`${process.env.VUE_APP_ROOT_API}/branches`, branch, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          const data = response.data;
          commit("ADD_BRANCH", data);
          resolve(data);
        })
        .catch((error) => {
          console.error("Failed to create branch", error);
          reject(error);
        });
    });
  },
  async updateBranch({ commit }, branch) {
      try {
        const token = localStorage.getItem('auth_token');
        const response = await axios.put(`${process.env.VUE_APP_ROOT_API}/branches/${branch.id}`, branch, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        commit('UPDATE_BRANCH', response.data);
      }
      catch (error) {
        console.error('Failed to update Branch:', error);
        throw error;
      }
  },
  async deleteBranchById({ commit }, id) {
      return new Promise((resolve, reject) => {
          const token = localStorage.getItem('auth_token');
          axios.delete(`${process.env.VUE_APP_ROOT_API}/branches/${id}`, {
              headers: {
              'Authorization': `Bearer ${token}`
              }
          })
          .then(response => {
              commit('REMOVE_BRANCH', id);
              resolve(response.data);
          })
          .catch(error => {
              console.error('Failed to delete Branch', error);
              reject(error);
          });
      });
  }
};

const getters = {
  allBranches: (state) => state.branches,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
